export const GET_NOTIFICATIONS = "GET_NOTIFICATIONS";
export const GET_FILTERED_NOTIFICATIONS = "GET_FILTERED_NOTIFICATIONS";
export const GET_UNFILTERED_NOTIFICATIONS = "GET_UNFILTERED_NOTIFICATIONS";
